import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {
  AddDashboardAction
} from '../../store/actions/admin-panel.action';
import {AdminPanelConfig} from '../../admin-panel.config';
import {AddDashboardCommand} from '../../commands/admin-panel.command';
import {FormBuilder} from '@angular/forms';
import {SmartGridService} from '@core/services/smart-grid.service';
import {ParticleService} from '@core/services/particle.service';
import {InvalidateSmartGridAction} from '@shared/store/actions/smart-grid.actions';
import {ConfirmationDialogComponent} from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import {ConfirmationDialogData} from '@shared/models/confirmation-dialog-data.model';
import {MatDialog} from '@angular/material/dialog';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';

@Component({
    standalone: false,
    selector: 'lib-user-content',
  templateUrl: './user-content.component.html',
  styleUrls: ['./user-content.component.scss']
})
export class UserContentComponent implements OnInit, OnDestroy {

  sourceType = 'Admin-Panel';
  selectedItems: any[];
  searchUserForm: any;
  unSubscribe$ = new Subject<void>();
  breadcrumbs: BreadcrumbModel[];
  constructor(public dialog: MatDialog,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>,
              private elementRef: ElementRef,
              private particleService: ParticleService,
              private smartGridService: SmartGridService) {

    this.selectedItems = [];
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'AdminPanel',
        title: 'Admin Panel',
        type: 'AdminPanel',
        relativeUrl: 'admin-panel/user',
      }, <BreadcrumbModel>{
        id: 'User',
        title: 'User',
        type: 'User',
        relativeUrl: 'admin-panel/user',
      },
    ];
  }

  ngOnInit() {
    // AdminPanelConfig.setSearchText(this.sourceType, '');
    const config = AdminPanelConfig.getSmartGridConfig(this.sourceType);
    this.smartGridService.initDataProvider(this.sourceType);

    this.searchUserForm = this.formBuilder.group({
      search: [decodeURIComponent(config.Parameters.SEARCH_TEXT)]
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onSelectionChanged(event) {
    this.selectedItems = event.allSelectedRows.map(function (obj) {
      return obj.dataItem;
    });
  }

  searchUsers(addClass = false) {
    if (addClass) {
      this.elementRef.nativeElement.querySelector('#searchButton').classList.add('mat-button-toggle-checked');
      this.elementRef.nativeElement.querySelector('#clearSearchButton').classList.remove('mat-button-toggle-checked');
    }

    let searchText = this.searchUserForm.controls['search'].value;
    if (searchText === undefined || searchText === null) {
      searchText = '';
    }
    AdminPanelConfig.setSearchText(this.sourceType, searchText);
    this.store.dispatch(new InvalidateSmartGridAction(this.sourceType, true, false, false));
  }

  clearSearchUsers() {
    this.elementRef.nativeElement.querySelector('#searchButton').classList.remove('mat-button-toggle-checked');
    this.elementRef.nativeElement.querySelector('#clearSearchButton').classList.add('mat-button-toggle-checked');
    this.searchUserForm.controls['search'].setValue('');
    this.searchUsers(false);
  }

  addUser() {

  }

  addDashboard() {
    const confirmationDialogData = new ConfirmationDialogData('Add Dashboard!', 'Do you really want to invite selected users to Platform?', ['No', 'Yes']);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: confirmationDialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Yes') {
        const selectedUsers = this.getSelectedUsers();

        if (selectedUsers.length > 0) {
          this.selectedItems = [];
          const command = new AddDashboardCommand(selectedUsers);
          this.store.dispatch(new AddDashboardAction(command));
        }
      }
    });
  }

  /*addSolution() {
    const dialogRef = this.dialog.open(AddSolutionComponent, {
      width: '600px',
      height: '430px',
      data: { products: [], solutions: [] }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.save) {
        const solutions = [];

        for (let i = 0; i < this.selectedItems.length; i++) {
          const solution = Object.assign({}, result.solution);

          solution.isActive = result.isActive;
          solution.expiryDate = result.expiryDate;
          solution.userName = this.selectedItems[i].cells.Username.displayText;
          solutions.push(solution);
        }

        if (solutions.length > 0) {
          console.log(solutions);
          this.selectedItems = [];
          const command = new AddSolutionCommand(solutions);
          this.store.dispatch(new AddSolutionAction(command));
        }
      }
    });
  }*/

  private getSelectedUsers() {
    const selectedUsers = [];

    for (let i = 0; i < this.selectedItems.length; i++) {
      const user = {
        firstName: this.selectedItems[i].cells.FirstName.displayText,
        lastName: this.selectedItems[i].cells.LastName.displayText,
        companyName: this.selectedItems[i].cells.Company.displayText,
        designation: this.selectedItems[i].cells.Designation.displayText,
        username: this.selectedItems[i].cells.Username.displayText,
        email: this.selectedItems[i].cells.Email.displayText,
        companyId: this.selectedItems[i].cells.CompanyId.displayText
      };
      selectedUsers.push(user);
    }

    return selectedUsers;
  }
}
